import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO from "@/components/SEO";

// Página 404.
//
// Antes no existía ninguna ruta comodín. Como el <Layout> se aplica ruta a
// ruta, una URL inexistente no coincidía con nada y <Routes> devolvía null:
// el visitante veía una página completamente en blanco, sin navbar ni pie,
// sin forma de volver.
const DESTINOS = [
  { to: "/palabra-del-dia", label: "Palabra del Día", desc: "El Evangelio de hoy y su reflexión" },
  { to: "/noticias", label: "Noticias", desc: "Actualidad de la delegación" },
  { to: "/formacion", label: "Formación", desc: "Cursos para evangelizadores digitales" },
  { to: "/contacto", label: "Contacto", desc: "Escríbenos" },
];

export default function NoEncontrada() {
  return (
    <>
      <SEO
        title="Página no encontrada"
        description="La página que buscas no existe o ha cambiado de dirección."
        noIndex
      />
      <div className="min-h-screen flex flex-col items-center justify-center px-6 py-32 text-center">
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-primary mb-5">
          Error 404
        </p>
        <h1
          className="font-heading font-bold text-foreground mb-5"
          style={{ fontSize: "var(--text-h1)", lineHeight: 1.05, letterSpacing: "-0.03em" }}
        >
          Esta página no existe
        </h1>
        <p className="text-lg text-muted-foreground max-w-xl mb-12 leading-relaxed">
          Puede que el enlace esté mal escrito o que el contenido haya cambiado
          de sitio. Te dejamos algunos destinos por si te sirven.
        </p>

        <div className="grid sm:grid-cols-2 gap-4 w-full max-w-2xl text-left">
          {DESTINOS.map(d => (
            <Link
              key={d.to}
              to={d.to}
              className="group bg-card rounded-2xl p-6 border border-border card-hover focus-ring"
            >
              <p className="font-heading font-semibold text-base mb-1 flex items-center gap-2">
                {d.label}
                <ArrowRight className="w-4 h-4 text-primary transition-transform duration-fast group-hover:translate-x-1" />
              </p>
              <p className="text-sm text-muted-foreground">{d.desc}</p>
            </Link>
          ))}
        </div>

        <Link
          to="/"
          style={{ borderRadius: "var(--radius-pill)" }}
          className="mt-12 px-8 py-3.5 text-sm font-medium bg-primary text-primary-foreground hover:opacity-90 transition-opacity focus-ring"
        >
          Volver al inicio
        </Link>
      </div>
    </>
  );
}
